import { OnInit } from '@angular/core';
import { ScrollTopService } from '../../shared/providers/scrolltop/scroll-top-service.service';
import { ApiService } from '../../services/api/api.service';
var FAQComponent = /** @class */ (function () {
    function FAQComponent(scrollTopService, api) {
        this.scrollTopService = scrollTopService;
        this.api = api;
        this.faqCategoryId = 1;
        this.faqActive = 0;
    }
    FAQComponent.prototype.ngOnInit = function () {
        this.scrollTopService.setScrollTop();
        this.getFaqs();
        this.getFaqsCategories();
    };
    FAQComponent.prototype.getFaqs = function () {
        var _this = this;
        this.api.get("faqs/category/" + this.faqCategoryId).subscribe(function (data) {
            _this.faqs = data;
        });
    };
    FAQComponent.prototype.getFaqsCategories = function () {
        var _this = this;
        this.api.get("list/faqCategories").subscribe(function (data) {
            _this.faqCategories = data;
        });
    };
    FAQComponent.prototype.viewIncrement = function (faqActive, faqId) {
        if (faqActive != this.faqActive) {
            this.api.get('faqsFO/' + faqId).subscribe(function (data) {
            });
        }
    };
    return FAQComponent;
}());
export { FAQComponent };
